<template>
  <div class="mt-3">
    <v-expansion-panel class="mb-3">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Filters</div>
        </template>
        <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
          <v-flex sm12 md6 lg2>
            <v-select
              solo flat
              label="Is Active"
              item-text="text"
              item-value="value"
              v-model="filters.is_active"
              :items="[
                { text: 'All', value: 'all' },
                { text: 'Active', value: 1 },
                { text: 'Inactive', value: 0 }
              ]"
            />
          </v-flex>
          <v-flex sm12 md12 lg2 style="display: flex; justify-content: center; margin-top: -17px;">
            <v-btn @click="applyFilters" color="primary" class="mt-3">
              Filter
            </v-btn>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <h4>Total {{ total_items }}</h4>
    <div style="display: flex;justify-content: end;">
      <v-btn
        v-if="checkedRows.length > 0"
        color="red"
        dark
        class="mb-3"
        @click="showDeleteDialog = true"
      >
        <v-icon left>delete</v-icon> ({{ checkedRows.length }})
      </v-btn>
    </div>
    <v-dialog v-model="showDeleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          Are you sure you want to delete <b>{{ checkedRows.length }}</b> selected coupon(s)?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
          <v-btn color="red" dark @click="deleteSelectedCoupons">
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      no-results-text="Loading... Please wait"
      :headers="headersWithCheckbox"
      :items="coupon_list"
      :pagination.sync="pagination"
      :loading="loaders.coupon_list_loader"
      :total-items="total_items"
      :rows-per-page-items="[10, 20, 50, 100]"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
              hide-details
              :input-value="allSelected"
              @change="toggleAll"
              :disabled="activeRows.length === 0"
            ></v-checkbox>
          </th>

          <th v-for="header in props.headers" :key="header.text">
            {{ header.text }}
          </th>
        </tr>
      </template>

      <template v-slot:items="props">
        <tr>
          <td style="display:flex; align-items:center; gap:8px;">
            <v-checkbox
              v-model="checkedRows"
              :value="String(props.item.id)"
              :disabled="props.item.is_active == 0"
              hide-details
            ></v-checkbox>
          </td>
          <td>{{ props.item.coupon_code }}</td>
          <td>{{ props.item.coupon_description || '-' }}</td>
          <td>{{ props.item.city ? props.item.city : 'All' }}</td>
          <td>{{ props.item.line_id ? props.item.line_id : 'All'}}</td>
          <td>{{ props.item.valid_from }}</td>
          <td>{{ props.item.valid_till }}</td>
          <td>
            <v-chip :color="getStatusColor(props.item)" dark>
              {{ getStatusLabel(props.item) }}
            </v-chip>
          </td>
          <td>{{ props.item.discount_type }}</td>
          <td>{{ props.item.discount_value }}</td>
          <td>
            <v-btn small icon color="primary" @click="copyCoupon(props.item)" title="Copy to form">
              <v-icon small>content_copy</v-icon>
            </v-btn>
          </td>

          <td v-if="showExtraColumns">{{ props.item.max_user_count }}</td>
          <td v-if="showExtraColumns">{{ props.item.allowed_user_id }}</td>
          <td v-if="showExtraColumns">{{ props.item.is_limited }}</td>
          <td v-if="showExtraColumns">{{ props.item.coupon_limit_upto }}</td>
          <td v-if="showExtraColumns">{{ props.item.min_total_amount }}</td>
          <td v-if="showExtraColumns">{{ props.item.discount_upto }}</td>
          <td v-if="showExtraColumns">{{ props.item.remaining_count }}</td>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-layout v-if="loaders.coupon_list_loader" justify-center>
          Loading... Please wait
        </v-layout>
        <v-layout v-else justify-center>
          No data available
        </v-layout>
      </template>
    </v-data-table>
    <v-snackbar :color="snackBar.color" :top="snackBar.top" :bottom="snackBar.bottom" :left="snackBar.left"
      :right="snackBar.right" v-model="snackBar.show">
      {{ snackBar.message }}
      <v-btn dark flat @click.native="snackBar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    
    return {
      current_date: new Date().toISOString().substr(0, 10),
      showExtraColumns: false,
      coupon_list: [],
      total_items: 0,

      checkedRows: [],
      showDeleteDialog: false,

      filters: {
        is_active: null,
      },

      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "",
        descending: true,
      },

      loaders: {
        coupon_list_loader: false,
      },

      snackBar: {
        show: false,
        message: "",
        color: "",
        top: true,
        right: true,
      },

      headers: [
        { text: "Coupon Code", value: "coupon_code" },
        { text: "Description", value: "coupon_description" },
        { text: "City", value: "city" },
        { text: "Line", value: "line_id" },
        { text: "Valid From", value: "valid_from" },
        { text: "Valid Till", value: "valid_till" },
        { text: "Active", value: "is_active" },
        { text: "Discount Type", value: "discount_type" },
        { text: "Discount Value", value: "discount_value" },
        { text: "Action", value: "action", sortable: false },

        // Hidden columns
        { text: "Max User Count", value: "max_user_count", hidden: true },
        { text: "Allowed User ID", value: "allowed_user_id", hidden: true },
        { text: "Is Limited", value: "is_limited", hidden: true },
        { text: "Coupon Limit Upto", value: "coupon_limit_upto", hidden: true },
        { text: "Min Total Amount", value: "min_total_amount", hidden: true },
        { text: "Discount Upto", value: "discount_upto", hidden: true },
        { text: "Remaining Count", value: "remaining_count", hidden: true },
      ],
    };
  },

  computed: {
    activeRows() {
      return this.coupon_list.filter(item => item.is_active == 1);
    },
    allSelected() {
      const activeRows = this.coupon_list.filter(item => item.is_active == 1);

      return (
        activeRows.length > 0 &&
        this.checkedRows.length === activeRows.length
      );
    },
    headersWithCheckbox() {
      return this.headers.filter(h => !h.hidden);
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getCouponList();
      },
      deep: true,
    },
  },

  mounted() {
    this.getCouponList();
  },

  methods: {
    applyFilters() {
      this.pagination.page = 1;
      this.getCouponList();
    },

    getCouponList() {
      this.loaders.coupon_list_loader = true;

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/get-coupons-list`,
          {},
          {
            headers: this.$headers,
            params: {
              page: this.pagination.page,
              rowsPerPage: this.pagination.rowsPerPage,
              sortBy: this.pagination.sortBy,
              descending: this.pagination.descending,
              is_active:
                this.filters.is_active === null
                  ? undefined
                  : this.filters.is_active,
            },
          }
        )
        .then((response) => {
          if (response.data.status == 1) {
            const payload = response.data || {};
            const paginatedData = payload.data || {};
            const list = Array.isArray(paginatedData.data)
              ? paginatedData.data
              : [];

            this.coupon_list = list;

            this.total_items =
              paginatedData.total !== undefined
                ? Number(paginatedData.total)
                : payload.total !== undefined
                  ? Number(payload.total)
                  : this.coupon_list.length;

            if (
              paginatedData.current_page &&
              Number(paginatedData.current_page) !== this.pagination.page
            ) {
              this.pagination.page = Number(paginatedData.current_page);
            }
            // Clear checked rows on data refresh
            this.checkedRows = [];
          }
        })
        .catch(() => {
          this.$toast && this.$toast.error("Something went wrong!");
        })
        .finally(() => {
          this.loaders.coupon_list_loader = false;
        });
    },

    toggleAll() {
      if (this.allSelected) {
        this.checkedRows = [];
      } else {
        // Select only active rows (is_active = 1)
        this.checkedRows = this.coupon_list
          .filter(item => item.is_active == 1)
          .map(item => String(item.id));
      }
    },

    deleteSelectedCoupons() {
      this.showDeleteDialog = false;

      if (this.checkedRows.length === 0) return;

      this.loaders.coupon_list_loader = true;

      axios.post(
        `${process.env.VUE_APP_API_URL}/api/v1/delete-coupon`,
        { ids: this.checkedRows },
        { headers: this.$headers }
      )
      .then((response) => {
        if (response.data.status === 1) {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          // alert(response.data.message || "Coupons deleted successfully!");
          this.getCouponList();
          this.checkedRows = [];
        } else {
          // alert(response.data.message || "Failed to delete coupons.");
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        } 
      })
      .catch(() => {
        this.$toast && this.$toast.error("Something went wrong!");
      })
      .finally(() => {
        this.loaders.coupon_list_loader = false;
      });
    },
    getStatusLabel(item) {
      if (item.valid_till < this.current_date) {
        return item.is_active == 1 ? "Expired" : "Inactive";
      }
      return item.is_active == 1 ? "Active" : "Inactive";
    },

    getStatusColor(item) {
      if (item.valid_till < this.current_date) {
        return item.is_active == 1 ? "grey" : "red";
      }
      return item.is_active == 1 ? "green" : "red";
    },

    copyCoupon(item) {
      const copyItem = {
        ...item,
        city_id: item.city_id != null ? item.city_id : (item.city != null ? item.city : null),
        line_id: item.line_id != null ? item.line_id : (item.line != null ? item.line : null),
      };

      this.$emit("copy-coupon", copyItem);
    },
  },
};
</script>
